import { useCallback, useState } from "react"

const KEY = "celver-copilot:work-iq"

// Work IQ is the default; only an explicit switch to Classic is stored.
function read(): boolean {
  try {
    return localStorage.getItem(KEY) !== "0"
  } catch {
    return true
  }
}

/**
 * Remembers whether the user last chose Work IQ (default) or Classic, per browser.
 * Storage is a convenience only; failures keep the in-memory value.
 */
export function useWorkIqPreference() {
  const [preferWorkIq, setPrefer] = useState<boolean>(read)

  const remember = useCallback((workIq: boolean) => {
    setPrefer(workIq)
    try {
      if (workIq) localStorage.removeItem(KEY)
      else localStorage.setItem(KEY, "0")
    } catch {
      // keep the in-memory state
    }
  }, [])

  return { preferWorkIq, remember }
}
